import './CharacterPaginator.css';

type CharacterPaginatorProps = {
  current: number;
  total: number;
};

/** Figma «Персонаж 4/6» (313:17160) — Matias 54, white 80%. */
export function CharacterPaginator({ current, total }: CharacterPaginatorProps) {
  return (
    <svg
      className="character-paginator"
      width={300}
      height={64}
      viewBox="0 0 300 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={`Персонаж ${current} из ${total}`}
      role="status"
    >
      <text
        className="character-paginator__text"
        textAnchor="middle"
        xmlSpace="preserve"
      >
        <tspan x={150} y={48}>
          {`Персонаж ${current}/${total}`}
        </tspan>
      </text>
    </svg>
  );
}
